import styled, {css} from "styled-components";
import {RectangularButtonFilled} from "../../components/buttons";
import {LayoutConst} from "../../../core";
import {BrgButton, Colors} from "@brg/ui";


export const ShareModalBody = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${p => p.theme.shareModal.bg};
  width: 720px;
  min-height: 332px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 32px 40px 40px 40px;
  row-gap: 24px;
  
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    width: 550px;
    min-height: 280px;
    row-gap: 16px;
    padding: 16px 20px 20px 20px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100vw;
    height: auto;
    min-height: auto;
    border-radius: 8px 8px 0 0;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.12);
    row-gap: 16px;
    padding: 32px 0px 24px;
  }
`

export const CloseModalIconWrapper = styled.div`
    position: absolute;
    right: 0;

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    right: 10px;
  }

  &:hover {
    svg path {
      fill: fill: ${({ theme }) => theme.subscribeInfo.hover};
    }
  }
`

export const ShareModalHeader = styled.div<{isVotingTitle?: boolean}>`
  color: ${({ theme }) => theme.app.text};
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: ${({isVotingTitle}) => isVotingTitle ? 22 : 28}px;
  line-height: ${({isVotingTitle}) => isVotingTitle ? 28 : 34}px;
  letter-spacing: -0.02em;

  @media(max-width: ${LayoutConst.screen.mac13}px) {
    font-size: ${({isVotingTitle}) => isVotingTitle ? 22 : 23}px;
    line-height: ${({isVotingTitle}) => isVotingTitle ? 28 : 27}px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: ${({isVotingTitle}) => isVotingTitle ? 17 : 17}px;
    line-height: ${({isVotingTitle}) => isVotingTitle ? 22 : 22}px;
    margin: 0 0 0 10px;
  }
`

export const ShareModalSend = styled.div<{isDisabled?: boolean}>`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: #909090;
  // color: ${Colors.galBlack10};
  column-gap: 0px;
  display: flex;
  align-items: center;
  //cursor: pointer;
  width: fit-content;
  white-space: nowrap;
  opacity: ${({isDisabled}) => isDisabled ? 0.5 : 1};
  cursor: ${({isDisabled}) => isDisabled ? 'auto' : 'pointer'};

  @media(max-width: ${LayoutConst.screen.m}px) {
    font-size: 15px;
    line-height: 20px;
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    justify-content: flex-start;
    width: 100%;
  }

  ${({ isDisabled, theme }) => !isDisabled && css`
    &:hover {
      .send-word {
        color: ${theme.subscribeInfo.hover};
      }

      svg path {
        fill: ${theme.subscribeInfo.hover};
      }
    }
  `}
`

export const ShareModalTransferBtn = styled.div<{ isDisabled?: boolean }>`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 34px;
  color: ${({ theme }) => theme.app.text};
  white-space: nowrap;
  cursor: ${({ isDisabled }) => (isDisabled ? 'auto' : 'pointer')};

  @media(max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 23px;
    line-height: 27px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 17px;
    line-height: 22px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    justify-content: center;
    width: 100%;
  }

  &:hover {
    .send-word {
      color: ${({ theme }) => theme.subscribeInfo.hover};
    }

    svg path {
      fill: #151514;
    }
  }
`

export const ShareModalUrlField = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 16px 13px;
  background: ${p => p.theme.shareModal.inputs.bg};
  border-radius: 3px;
  height: 44px;
  flex: 1;
  min-width: 0;

  span {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #909090;
    min-width: 0;
    flex: 1;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const ShareModalUrlButton = styled(RectangularButtonFilled)<{isGameDeziiign?: boolean}>`
  height: 44px !important;
  width: 151px !important;
  min-width: 151px !important;
  max-width: 151px !important;
  ${({isGameDeziiign}) => isGameDeziiign && css`
    color: ${Colors.geoWhite100};
    background: ${Colors.galBlack100};
  `}
  
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: calc(100% - 20px) !important;
    min-width: calc(100% - 20px) !important;
    max-width: calc(100% - 20px) !important;
    height: 38px !important;
    margin: 0px 10px;
    
    span {
      margin-left: 8px;
    }
  }
  
  svg {
    path {
      fill: ${({theme}) => theme.navigationBar.btns.filled.text.main};
      stroke: ${({theme}) => theme.navigationBar.btns.filled.text.main};

      ${p => p.importantStyles ? css`
        fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.main};
        stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.main};
    ` : null}

      &:hover {
        ${p => p.importantStyles ? css`
          fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
          stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
    ` : null}
      }
      
      &:active {
        ${p => p.importantStyles ? css`
          fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
          stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
    ` : null}
    }
    &:disabled {
        fill: ${({theme}) => theme.navigationBar.btns.filled.text.disabled};

        ${p => p.importantStyles ? css`
          fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
          stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
    ` : null}
    }
    }
  }
`

export const SubmitModalShareButton = styled(BrgButton)`
  min-width: unset!important;
  max-width: unset!important;
  width: auto!important;
  font-weight: 600;
`

export const ShareModalSendRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  gap: 12px;

  & ${ShareModalSend} {
    max-width: 100%;
    white-space: normal;
  }

  .platform-name {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #151514;
    white-space: nowrap;
  }
`;

export const ShareModalBottomRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 24px;
  width: 100%;

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
    padding: 0 10px;
    box-sizing: border-box;

    & ${ShareModalSend} {
      width: fit-content;
      justify-content: flex-start;
    }
  }
`;

export const PrintPDFButton = styled.div`
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.34px;
  color: ${Colors.galBlack47};
  white-space: nowrap;
  cursor: pointer;
  display: flex;
  gap: 8px;

  svg {
    position: relative;
    top: -5px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    justify-content: center;
    width: 100%;
    padding: 12px 16px;
    border: 1px solid ${Colors.zel};
    border-radius: 3px;
    background: #FEFEFE;
    color: ${Colors.zel};
    box-sizing: border-box;
  }

  &:hover {
      color: ${({ theme }) => theme.subscribeInfo.hover};

    svg path {
      fill: ${({ theme }) => theme.subscribeInfo.hover};
    }
  }
`import styled, {css} from "styled-components";
import {RectangularButtonFilled} from "../../components/buttons";
import {LayoutConst} from "../../../core";
import {BrgButton, Colors} from "@brg/ui";


export const ShareModalBody = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${p => p.theme.shareModal.bg};
  width: 720px;
  min-height: 332px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 32px 40px 40px 40px;
  row-gap: 24px;
  
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    width: 550px;
    min-height: 280px;
    row-gap: 16px;
    padding: 16px 20px 20px 20px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100vw;
    height: auto;
    min-height: auto;
    border-radius: 8px 8px 0 0;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.12);
    row-gap: 16px;
    padding: 32px 0px 24px;
  }
`

export const CloseModalIconWrapper = styled.div`
    position: absolute;
    right: 0;

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    right: 10px;
  }

  &:hover {
    svg path {
      fill: fill: ${({ theme }) => theme.subscribeInfo.hover};
    }
  }
`

export const ShareModalHeader = styled.div<{isVotingTitle?: boolean}>`
  color: ${({ theme }) => theme.app.text};
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: ${({isVotingTitle}) => isVotingTitle ? 22 : 28}px;
  line-height: ${({isVotingTitle}) => isVotingTitle ? 28 : 34}px;
  letter-spacing: -0.02em;

  @media(max-width: ${LayoutConst.screen.mac13}px) {
    font-size: ${({isVotingTitle}) => isVotingTitle ? 22 : 23}px;
    line-height: ${({isVotingTitle}) => isVotingTitle ? 28 : 27}px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: ${({isVotingTitle}) => isVotingTitle ? 17 : 17}px;
    line-height: ${({isVotingTitle}) => isVotingTitle ? 22 : 22}px;
    margin: 0 0 0 10px;
  }
`

export const ShareModalSend = styled.div<{isDisabled?: boolean}>`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: #909090;
  // color: ${Colors.galBlack10};
  column-gap: 0px;
  display: flex;
  align-items: center;
  //cursor: pointer;
  width: fit-content;
  white-space: nowrap;
  opacity: ${({isDisabled}) => isDisabled ? 0.5 : 1};
  cursor: ${({isDisabled}) => isDisabled ? 'auto' : 'pointer'};

  @media(max-width: ${LayoutConst.screen.m}px) {
    font-size: 15px;
    line-height: 20px;
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    justify-content: flex-start;
    width: 100%;
  }

  ${({ isDisabled, theme }) => !isDisabled && css`
    &:hover {
      .send-word {
        color: ${theme.subscribeInfo.hover};
      }

      svg path {
        fill: ${theme.subscribeInfo.hover};
      }
    }
  `}
`

export const ShareModalTransferBtn = styled.div<{ isDisabled?: boolean }>`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 34px;
  color: ${({ theme }) => theme.app.text};
  white-space: nowrap;
  cursor: ${({ isDisabled }) => (isDisabled ? 'auto' : 'pointer')};

  @media(max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 23px;
    line-height: 27px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 17px;
    line-height: 22px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    justify-content: center;
    width: 100%;
  }

  &:hover {
    .send-word {
      color: ${({ theme }) => theme.subscribeInfo.hover};
    }

    svg path {
      fill: #151514;
    }
  }
`

export const ShareModalUrlField = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 16px 13px;
  background: ${p => p.theme.shareModal.inputs.bg};
  border-radius: 3px;
  height: 44px;
  flex: 1;
  min-width: 0;

  span {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #909090;
    min-width: 0;
    flex: 1;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const ShareModalUrlButton = styled(RectangularButtonFilled)<{isGameDeziiign?: boolean}>`
  height: 44px !important;
  width: 151px !important;
  min-width: 151px !important;
  max-width: 151px !important;
  ${({isGameDeziiign}) => isGameDeziiign && css`
    color: ${Colors.geoWhite100};
    background: ${Colors.galBlack100};
  `}
  
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: calc(100% - 20px) !important;
    min-width: calc(100% - 20px) !important;
    max-width: calc(100% - 20px) !important;
    height: 38px !important;
    margin: 0px 10px;
    
    span {
      margin-left: 8px;
    }
  }
  
  svg {
    path {
      fill: ${({theme}) => theme.navigationBar.btns.filled.text.main};
      stroke: ${({theme}) => theme.navigationBar.btns.filled.text.main};

      ${p => p.importantStyles ? css`
        fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.main};
        stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.main};
    ` : null}

      &:hover {
        ${p => p.importantStyles ? css`
          fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
          stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
    ` : null}
      }
      
      &:active {
        ${p => p.importantStyles ? css`
          fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
          stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
    ` : null}
    }
    &:disabled {
        fill: ${({theme}) => theme.navigationBar.btns.filled.text.disabled};

        ${p => p.importantStyles ? css`
          fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
          stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
    ` : null}
    }
    }
  }
`

export const SubmitModalShareButton = styled(BrgButton)`
  min-width: unset!important;
  max-width: unset!important;
  width: auto!important;
  font-weight: 600;
`

export const ShareModalSendRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  gap: 12px;

  & ${ShareModalSend} {
    max-width: 100%;
    white-space: normal;
  }

  .platform-name {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #151514;
    white-space: nowrap;
  }
`;

export const ShareModalBottomRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 24px;
  width: 100%;

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
    padding: 0 10px;
    box-sizing: border-box;

    & ${ShareModalSend} {
      width: fit-content;
      justify-content: flex-start;
    }
  }
`;

export const PrintPDFButton = styled.div`
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.34px;
  color: ${Colors.galBlack47};
  white-space: nowrap;
  cursor: pointer;
  display: flex;
  gap: 8px;

  svg {
    position: relative;
    top: -5px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    justify-content: center;
    width: 100%;
    padding: 12px 16px;
    border: 1px solid ${Colors.zel};
    border-radius: 3px;
    background: #FEFEFE;
    color: ${Colors.zel};
    box-sizing: border-box;
  }

  &:hover {
      color: ${({ theme }) => theme.subscribeInfo.hover};

    svg path {
      fill: ${({ theme }) => theme.subscribeInfo.hover};
    }
  }
`